/**
 * Patient Detail Route
 * Dynamic route for individual patient profile pages
 * Layout provided by _authenticated parent route
 * Authentication inherited from parent
 */

import {
  createFileRoute,
  useNavigate,
  useParams,
} from "@tanstack/react-router";
import { PatientDetailPage } from "../../pages/Patients/PatientDetailPage";

/**
 * Patient Detail Route Component
 * Layout (MainLayout, Sidebar, sessions panel) provided by parent _authenticated route
 */
const PatientDetailRouteComponent = () => {
  const navigate = useNavigate();
  const { patientId } = useParams({
    from: "/_authenticated/patients/$patientId",
  });

  const handleBack = () => {
    navigate({ to: "/patients" });
  };

  return <PatientDetailPage patientId={patientId} onBack={handleBack} />;
};

/**
 * Route Configuration
 * Path: /_authenticated/patients/$patientId
 * - Authentication inherited from _authenticated parent (no requireAuth needed)
 * - MainLayout structure inherited from _authenticated parent
 */
export const Route = createFileRoute("/_authenticated/patients/$patientId")({
  component: PatientDetailRouteComponent,
});
